import React from 'react';

import { gql } from '@apollo/client';

import { ActivityLogTaskRequirementCandidateAvailabilityRemoved_ActivityLogFragment } from 'src/generated/mloop-graphql';

import { FCWithFragments } from 'src/components/types';

import ActivityLogBase from '../../Helpers/ActivityLogBase';

interface Fragments {
  activityLog: ActivityLogTaskRequirementCandidateAvailabilityRemoved_ActivityLogFragment;
}

const ActivityLogTaskRequirementCandidateAvailabilityRemoved: FCWithFragments<Fragments> = ({ activityLog }) => {
  return (
    <ActivityLogBase
      activityLog={activityLog}
      actionLabelKey="hiring-dashboard-candidates:candidates.activityLog.removedAvailabilityRequirement"
    />
  );
};

ActivityLogTaskRequirementCandidateAvailabilityRemoved.fragments = {
  activityLog: gql`
    ${ActivityLogBase.fragments.activityLog}
    fragment ActivityLogTaskRequirementCandidateAvailabilityRemoved_activityLog on ActivityLog {
      id

      ...ActivityLogBase_activityLog
    }
  `,
};

export default ActivityLogTaskRequirementCandidateAvailabilityRemoved;
